
import { defineComponent } from "vue";

export default defineComponent({
  props: ["message"],
  setup() {
    return {};
  }
});
